import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { canActivateWithAccessGuard } from '@/app/core/auth/access-guard';
import { atLeastGroupAdmin } from '@/app/core/auth/auth-pipes';
import { CreateUserSegmentPageComponent } from './pages/create-usersegment-module/create-usersegment-page.component';
import { YourUserSegmentsPageComponent } from './pages/your-usersegments-page/your-usersegments-page.component';
import { UsersegmentsPageComponent } from './usersegments-page.component';

const routes: Routes = [
  {
    path: '',
    component: UsersegmentsPageComponent,
    ...canActivateWithAccessGuard(atLeastGroupAdmin),
    children: [
      {
        path: 'create',
        component: CreateUserSegmentPageComponent,
      },
      {
        path: 'list',
        component: YourUserSegmentsPageComponent,
      },
      { path: '', redirectTo: 'list' },
    ],
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)],
})
export class UsersegmentsPageRoutingModule {}
